import { Box, Dialog, DialogContent, DialogTitle, Grid, Paper } from "@material-ui/core";
import MaterialTable from "material-table";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { createMenu, deleteMenuById, getAllMenu, updateMenuById } from "../../../api/menuApi";
import Color from "../../../styles/Color";
import FormCreateMenu from "./components/FormCreateMenu";
import { useSelector } from "react-redux";

function MenuManagement() {
    // ref
    const controllerRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // component state
    const [dataMenu, setDataMenu] = useState([]);
    const [idForUpdate, setIdForUpdate] = useState("");
    const [isToggleModal, setIsToggleModal] = useState(false);
    const [dataCreatemenu, setDataCreatemenu] = useState({
        menuControlName: "",
        menuControlPart: "",
        menuControlIcon: "",
        menuControlMainSub: 0,
        menuControlIndex: 0,
    });

    const getDataMenu = useCallback(async signal => {
        setDataMenu([]);
        const _menus = await getAllMenu(signal);
        if (_menus) {
            const allMenu = _menus.filter(row => row?.menuControlStatus !== 0);
            setDataMenu(allMenu);
        }
    }, []);

    useEffect(() => {
        controllerRef.current = new AbortController();
        const fetch = async () => {
            getDataMenu(controllerRef.current?.signal);
        };
        fetch();
        return () => {
            controllerRef.current.abort();
        };
    }, [getDataMenu]);

    // edit menu
    const setForm_edit = async data => {
        await setIdForUpdate("");
        await setDataCreatemenu({
            menuControlIndex: data.menuControlIndex,
            menuControlName: data.menuControlName,
            menuControlPart: data.menuControlPart,
            menuControlIcon: data.menuControlIcon,
            menuControlMainSub: data.menuControlMainSub,
        });
        await setIdForUpdate(data.id);
        setIsToggleModal(true);
    };

    const deleteMenu = data => {
        Swal.fire({
            title: "คุณแน่ใจใช่หรือไม่?",
            text: "หากแน่ใจกดตกลง!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
            allowOutsideClick: false,
        }).then(async result => {
            if (result.isConfirmed) {
                const res = await deleteMenuById(data?.id, controllerRef.current?.signal);
                getDataMenu();
                if (res?.status) {
                    Swal.fire({
                        icon: "success",
                        title: "ลบข้อมูลสำเร็จ",
                        showConfirmButton: false,
                        timer: 1200,
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "ผิดพลาด!",
                        text: "กรุณาลองใหม่อีกครั้ง",
                    });
                }
            }
        });
    };

    // function insert menu list
    const fn_onSubmitFormCreateMenu = async vals => {
        const res = await createMenu(vals, controllerRef.current?.signal);
        getDataMenu();
        if (res?.status) {
            Swal.fire({
                icon: "success",
                title: "สร้างข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1200,
            });
        } else {
            Swal.fire({
                icon: "error",
                title: "ผิดพลาด!",
                text: "กรุณาลองใหม่อีกครั้ง",
            });
        }
    };
    // function insert menu list
    const fn_onSubmitFormUpdateMenu = async vals => {
        const res = await updateMenuById(idForUpdate, vals, controllerRef.current?.signal);
        await setIdForUpdate("");
        await setIsToggleModal(false);
        getDataMenu();
        if (res?.status) {
            Swal.fire({
                icon: "success",
                title: "อัพเดทข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1200,
            });
        } else {
            Swal.fire({
                icon: "error",
                title: "ผิดพลาด!",
                text: "กรุณาลองใหม่อีกครั้ง",
            });
        }
    };

    return (
        <div>
            <Box>
                <Grid container>
                    <Grid item xs={12} className="mb-5">
                        <h1 style={{ color: Color.primary }}>Menu Managements</h1>
                    </Grid>
                    {/* FORM CREATE MENU */}
                    {thisMenuPermission?.create && (
                        <Grid item xs={12} className="mb-3">
                            <Paper elevation={2}>
                                <Box className="p-4">
                                    <FormCreateMenu
                                        BtnTitle={"Create menu"}
                                        handleSubmit={vals => {
                                            fn_onSubmitFormCreateMenu(vals);
                                        }}
                                    />
                                </Box>
                            </Paper>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <div className="t-table-custom">
                            <MaterialTable
                                data={dataMenu}
                                className="table-responsive"
                                style={{ width: "100%" }}
                                title={null}
                                isLoading={dataMenu.length < 1 ? true : false}
                                columns={[
                                    {
                                        title: "Name",
                                        align: "center",
                                        field: "menuControlName",
                                        render: row => `${row.menuControlName}`,
                                    },
                                    {
                                        title: "Part",
                                        align: "center",
                                        field: "menuControlPart",
                                        render: row => `${window.location.host}/${row.menuControlPart}`,
                                    },
                                    {
                                        title: "Icon",
                                        align: "center",
                                        field: "menuControlIcon",
                                        render: row => `${row.menuControlIcon}`,
                                    },
                                    {
                                        title: "Menu MainSub",
                                        align: "center",
                                        field: "menuControlMainSub",
                                        render: row => `${row.menuControlMainSub}`,
                                    },
                                    {
                                        title: "Index",
                                        align: "center",
                                        field: "menuControlIndex",
                                        render: row => `${row.menuControlIndex}`,
                                    },
                                ]}
                                actions={[
                                    {
                                        icon: "edit",
                                        iconProps: { className: "action-edit" },
                                        tooltip: "Edit",
                                        onClick: (event, rowData) => {
                                            // Do save operation
                                            setForm_edit(rowData);
                                        },
                                        hidden: !thisMenuPermission?.edit,
                                    },
                                    {
                                        icon: "delete",
                                        iconProps: { className: "action-delete" },
                                        tooltip: "Delete",
                                        onClick: (event, rowData) => {
                                            // Do save operation
                                            deleteMenu(rowData);
                                        },
                                        hidden: !thisMenuPermission?.delete,
                                    },
                                ]}
                                options={{
                                    pageSize: 20,
                                    pageSizeOptions: [10, 20, 50],
                                    actionsColumnIndex: -1,
                                    headerStyle: {
                                        fontSize: 15,
                                    },
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Dialog open={isToggleModal} onClose={() => setIsToggleModal(false)}>
                            <DialogTitle>Update menu</DialogTitle>
                            <DialogContent>
                                {idForUpdate === "" ? (
                                    <></>
                                ) : (
                                    <FormCreateMenu
                                        BtnTitle={"Update menu"}
                                        dataInitial={dataCreatemenu}
                                        handleSubmit={vals => {
                                            fn_onSubmitFormUpdateMenu(vals);
                                        }}
                                    />
                                )}
                            </DialogContent>
                        </Dialog>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
}

export default MenuManagement;
